module.exports = __webpack_public_path__ + "static/img/twjd-sdc2.349b73e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/twjd-sdc2.png
// module id = 832
// module chunks = 0